/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function(){

    document.querySelectorAll('.leading-trainer-inner').forEach((section) => {
        new Swiper(section.querySelector('.leading-trainer-blocks'), {       
            slidesPerView: 1.3,
            spaceBetween: 20,
            loop: false,
            pagination: {
            el: section.querySelector('.swiper-pagination-leading-trainer'),
            clickable: true,
            },
            breakpoints: {
                741: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
                1300: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                }
            }
        });
    });

    document.querySelectorAll('.testimonial-secondary-inner').forEach((section) => {
        new Swiper(section.querySelector('.testimonial-sec-blocks'), {       
            slidesPerView: 1.5,
            spaceBetween: 10,
            loop: false,
            pagination: {
                el: section.querySelector('.swiper-pagination-testimonial'),
                clickable: true,
            },
            breakpoints: {
                741: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
                1300: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                }
            }
        });
    });

    // IMAGE WITH ACCORDION
    $("body").on("click", ".iwac-block-title", function () {
        var activeTitle = $(this);
        activeTitle.toggleClass("active");
        var currentDropdown = activeTitle.next(".iwac-block-text");
        $(".iwac-block-title").not(activeTitle).removeClass("active");
        $(".iwac-block-text").not(currentDropdown).slideUp();
        currentDropdown.stop(true, true).slideToggle();
    });

    // CUSTOM FAQS
    $("body").on("click", ".iwfb-title", function () {
        var activeTitle = $(this);
        activeTitle.toggleClass("active");
        var currentDropdown = activeTitle.next(".iwfb-text");
        $(".iwfb-title").not(activeTitle).removeClass("active");
        $(".iwfb-text").not(currentDropdown).slideUp();
        currentDropdown.stop(true, true).slideToggle();
    });

    // PDP ACCORDION
    $("body").on("click", ".product-form__accordion-title", function () {
        var activeTitle = $(this);
        activeTitle.toggleClass("active");
        var currentDropdown = activeTitle.next(".product-form__accordion-content");
        $(".product-form__accordion-title").not(activeTitle).removeClass("active");
        $(".product-form__accordion-content").not(currentDropdown).slideUp();
        currentDropdown.stop(true, true).slideToggle();
    });

    // PDP FEATURES TABS
    $('body').on('click','.pdp-f-t-m-tab', function() {
        $(this).closest('.pdp-f-t-m-tabs').find('.pdp-f-t-m-tab').removeClass('is-active')
        $(this).addClass('is-active');
        let tab_title = $(this).attr('data-tab');
        $(this).closest('.pdp-featured-tab-media').find('.pdp-f-t-m-panel').each(function() {
            let tab_panel = $(this).attr('data-panel');
            if (tab_title == tab_panel) {
                $(this).addClass('is-active');
            } else {
                $(this).removeClass('is-active');
            }
        })
    })

    // PDP SIZE MATERIAL
    $('body').on('click', '.pdp-s-m-i-tab', function() {
      $(this).closest('.pdp-s-m-i-tabs').find('.pdp-s-m-i-tab').removeClass('is-active');
      $(this).addClass('is-active');

      let tab_title = $(this).attr('data-tab');
      let $inner = $(this).closest('.pdp-size-material-inner');

      $inner.find('.pdp-s-m-i-panel').each(function() {
          $(this).toggleClass('is-active', $(this).attr('data-panel') == tab_title);
      });

      $inner.find('.pdp-s-m-i-image').each(function() {
          $(this).toggleClass('is-active', $(this).attr('data-media') == tab_title);
      });
  });

    // VIEW COUPONS CART DRAWER
    $("body").on("click",".cart-offer-view-more-btn", function () {
        $(this).closest("#mini-cart").find("#coupon-offers").attr("open","true");
    })
    $('body').on('click', '.toggle-term-condition', function() {
      $(this).toggleClass('active');
        $(this).parents('.coupon_offer-item').find('.term-condition_wrapper').toggle();
        if ($(this).hasClass('active')) {
        $(this).text('-hide');
      } else {
        $(this).text('+more');
      }
    });

    // CART COUPONS APPLY
    function existingDiscounts(){
      const discountCodes = [];
      const discountPills = $('.mini-cart').find('.applied_coupon-item');
      for (const pill of discountPills) {
          if (typeof $(pill).attr('data-discount-code') === 'string') {
              discountCodes.push($(pill).attr('data-discount-code'));
          }
      }
      return [...new Set(discountCodes)];
    }
    function applied_code(discountCodeValue, _this, sectionId){
        console.log('0000',discountCodeValue, _this, sectionId)
        var existingDiscountsValue = existingDiscounts();
        if (existingDiscountsValue.includes(discountCodeValue)) return;
        console.log('111111111111111')
    
        $(_this).attr("disabled","disabled");
        $(_this).attr("loading","loading");

        async function getupdatedata(){     
        let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
            method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
            headers : {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({
            discount: [...existingDiscountsValue, discountCodeValue].join(','),
            sections: [sectionId]
            })
        });
        const data = await response.json();
        return data;
        }
        getupdatedata().then(data => {
        console.log(data);
        if (data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
            return discount.code === discountCodeValue && discount.applicable === false;
            })
        ) {
            $(_this).removeAttr('disabled');                                    
            $(_this).removeAttr('loading'); 
            $(_this).removeClass('loading');
            $('.cart-offer-coupon_applied-message').append(`<div id="applied_code_error" class="applied_code_error text--xsmall">This discount code cannot be applied to your cart</div>`);
            setTimeout(function(){
            $('.applied_code_error').remove();
            },2000);
            return;
        }
        
        // const newHtml = data.sections[sectionId];
        // const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
        // $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());
        // $('#coupon-offers').html($(parsedHtml).find('#coupon-offers').html());
        // $(_this).removeClass('loading');
        $.getJSON("/cart.js", function (cart) {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { cart }
            })); 
        });
        });
    }

    $('body').on('keyup','.cart-offer-coupon_input-field', function(){
        if($(this).val() != ''){
            $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_apply-button').addClass('active'); 
            }else{
            $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_apply-button').removeClass('active');
            }    
        });

        $('body').on('click','.cart-offer-coupon_apply-button.active', function(){
        var _this  = this;
        var discountCodeValue = $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_input-field').val();
        var sectionId = $(_this).closest('cart-drawer').attr('section');
        if(discountCodeValue == ''){
        _this.closest('.cart-offer-coupon_input').after('<p class="offer_input_err">Please enter any code above.</p>');
        return;
        }
        $(_this).attr("disabled","disabled");
        $(_this).attr("loading","loading");

        $('#applied_code_error').remove();
        applied_code(discountCodeValue, _this, sectionId);
    });

    $('body').on('click','.coupon_offer-item_code-copy', function(){
        var _this  = this;
        var discountCodeValue = $(this).attr('coupon');
        var sectionId = $(_this).closest('cart-drawer').attr('section');

        $(_this).removeAttr('disabled');                                    
        $(_this).removeAttr('loading'); 
        $(_this).removeClass('loading');

        $('#applied_code_error').remove();
        applied_code(discountCodeValue, _this, sectionId);
    });

    $('body').on('click','.shipping-notes-wrapper-coupon-btn', function(){
        var _this  = this;
        var discountCodeValue = $(this).attr('coupon-code');
        var sectionId = $(_this).closest('cart-drawer').attr('section');

        $(_this).removeAttr('disabled');                                    
        $(_this).removeAttr('loading'); 
        $(_this).removeClass('loading');

        $('#applied_code_error').remove();
        applied_code(discountCodeValue, _this, sectionId);
    });

    // COUPON BUTTONS — reflect applied state
    var COUPON_APPLY_BUTTONS = [
        { selector: '.shipping-notes-wrapper-coupon-btn', attr: 'coupon-code' },
        { selector: '.coupon_offer-item_code-copy',       attr: 'coupon' }
    ];

    function syncCouponApplyButtons() {
        var appliedCodes = existingDiscounts().map(function (code) {
            return (code || '').toLowerCase();
        });

        COUPON_APPLY_BUTTONS.forEach(function (config) {
            $(config.selector).each(function () {
                var $btn = $(this);
                var isApplied = appliedCodes.includes(($btn.attr(config.attr) || '').toLowerCase());
                var newText = isApplied ? 'Applied' : 'Apply';

                // only touch the DOM if it actually changed (prevents observer loop)
                if ($btn.text() !== newText) $btn.text(newText);
                if ($btn.hasClass('is-applied') !== isApplied) $btn.toggleClass('is-applied', isApplied);
            });
        });
    }

    syncCouponApplyButtons();

    var miniCartEl = document.getElementById('mini-cart');
    if (miniCartEl) {
        var couponSyncTimer;
        new MutationObserver(function () {
            clearTimeout(couponSyncTimer);
            couponSyncTimer = setTimeout(syncCouponApplyButtons, 50);
        }).observe(miniCartEl, { childList: true, subtree: true });
    }

    $('body').on('click','[data-removecode]', function(){
        var _this  = this;
        console.log('hhiiihi')
        var sectionId = $(this).closest('cart-drawer').attr('section');
        var discountCodeValue = $(this).closest('.applied_coupon-item').attr('data-discount-code');
        var existingDiscountsValue = existingDiscounts();
        console.log('existingDiscountsValue:', existingDiscountsValue);

        $(_this).attr("disabled","disabled");
        $(_this).attr("loading","loading");
        
        if (!existingDiscountsValue.includes(discountCodeValue)) {
              $(_this).removeAttr('disabled');
              $(_this).removeAttr('loading');
              return;
          }

          existingDiscountsValue = existingDiscountsValue.filter(function(code){
              return code !== discountCodeValue;
          });
        
        async function getupdatedata(){     
        let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
            method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
            headers : {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ 
            discount: existingDiscountsValue.join(','),
            sections: [sectionId]
            })
        });
        const data = await response.json();
        return data;
        }
        getupdatedata().then(data => {
        console.log(data);
        // const newHtml = data.sections[sectionId];
        // const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
        // console.log(parsedHtml);
        // $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());
        // $('#coupon-offers').html($(parsedHtml).find('#coupon-offers').html());

        $(_this).removeAttr('disabled');                                    
        $(_this).removeAttr('loading'); 
        $(_this).removeClass('loading');
        
        $.getJSON("/cart.js", function (cart) {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { cart }
            })); 
        });
        });
    });

  (function ($) {
    var NAMESPACE = '.productDescription{{ section.id }}';

    function init(scope) {
      $(scope).find('[data-product-description]').each(function () {
        var $wrapper = $(this);
        var $rest = $wrapper.find('[data-description-rest]').first();
        var $toggle = $wrapper.find('[data-description-toggle]').first();

        if (!$rest.length || !$toggle.length) return;

        // destroy before re-init
        $toggle.off(NAMESPACE);

        $toggle.on('click' + NAMESPACE, function () {
          var isExpanded = $wrapper.hasClass('is-expanded');

          $wrapper.toggleClass('is-expanded', !isExpanded);
          $rest.prop('hidden', isExpanded);
          $toggle
            .attr('aria-expanded', String(!isExpanded))
            .text(isExpanded ? $toggle.attr('data-text-more') : $toggle.attr('data-text-less'));
        });
      });
    }

    $(document).ready(function () {
      init(document);
    });

    $(document).on('shopify:section:load' + NAMESPACE, function (event) {
      init(event.target);
    });

    $(document).on('shopify:section:unload' + NAMESPACE, function (event) {
      $(event.target).find('[data-description-toggle]').off(NAMESPACE);
    });
  })(jQuery);


  // var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  // function updateBundleTotal() {
  //   var total = 0;

  //   $('bundle-addon').each(function () {
  //     var $addon = $(this);
  //     if ($addon.find('.bundle-addon__check').is(':checked')) {
  //       total += parseInt($addon.attr('data-price'), 10);
  //     }
  //   });

  //   $('[data-bundle-total]').html(formatMoney(total, currencyFormat));
  // }
  // $(document).on('change.bundleAddon', '.bundle-addon__check', updateBundleTotal);
  // $(document).on('addon:variant:change', updateBundleTotal);

  // (function ($) {
  //   'use strict';
  
  //   var currencyFormat = window.themeVariables.settings.currencyCodeEnabled
  //     ? window.themeVariables.settings.moneyWithCurrencyFormat
  //     : window.themeVariables.settings.moneyFormat;
  
  //   function updateBundleTotal($form) {
  //     var total = 0;
  
  //     $form.find('bundle-addon').each(function () {
  //       var $addon = $(this);
  
  //       if ($addon.find('.bundle-addon__check').prop('checked')) {
  //         total += parseInt($addon.attr('data-price'), 10) || 0;
  //       }
  //     });
  
  //     $form.find('[data-bundle-total]').html(formatMoney(total, currencyFormat));
  //   }
  
  //   function updateAddon($addon) {
  //     var variants = JSON.parse($addon.find('script[data-addon-variants]').text());
  //     var selected = [];
  
  //     $addon.find('[data-addon-option]:checked').each(function () {
  //       selected[parseInt(this.dataset.optionPosition, 10) - 1] = this.value;
  //     });
  
  //     var variant = variants.find(function (candidate) {
  //       return candidate.options.every(function (option, index) {
  //         return selected[index] === undefined || option === selected[index];
  //       });
  //     });
  
  //     if (!variant) return;
  
  //     $addon
  //       .attr('data-variant-id', variant.id)
  //       .attr('data-price', variant.price)
  //       .toggleClass('is-unavailable', !variant.available);
  
  //     $addon.find('[data-addon-price]').html(formatMoney(variant.price, currencyFormat));
  //   }
  
  //   function collectItems($form, quantity) {
  //     var items = [];
  
  //     $form.find('bundle-addon').each(function () {
  //       var $addon = $(this);
  
  //       if (!$addon.find('.bundle-addon__check').prop('checked')) return;
  //       if ($addon.hasClass('is-unavailable')) return;
  
  //       items.push({
  //         id: parseInt($addon.attr('data-variant-id'), 10),
  //         quantity: quantity
  //       });
  //     });
  
  //     return items;
  //   }
  
  //   function addToCart($button) {
  //     var $form = $button.closest('.product-form');
  //     var quantity = parseInt($button.closest('bundle-form').find('[name="quantity"]').val(), 10) || 1;
  //     var items = collectItems($form, quantity);
  
  //     if (!items.length) return;
  
  //     $button.attr('aria-busy', 'true');
  
  //     $.ajax({
  //       url: window.themeVariables.routes.cartAddUrl + '.js',
  //       type: 'POST',
  //       dataType: 'json',
  //       contentType: 'application/json',
  //       data: JSON.stringify({ items: items })
  //     })
  //       .done(function () {
  //         document.documentElement.dispatchEvent(
  //           new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } })
  //         );
  //       })
  //       .fail(function (xhr) {
  //         alert((xhr.responseJSON && xhr.responseJSON.description) || 'Could not add to cart.');
  //       })
  //       .always(function () {
  //         $button.removeAttr('aria-busy');
  //       });
  //   }
  
  //   $(document).on('click.bundleAddon', '[data-bundle-add-to-cart-button]', function (event) {
  //     event.preventDefault();
  //     addToCart($(this));
  //   });
  
  //   $(document).on('change.bundleAddon', '[data-addon-option]', function () {
  //     var $addon = $(this).closest('bundle-addon');
  
  //     updateAddon($addon);
  //     updateBundleTotal($addon.closest('.product-form'));
  //   });
  
  //   $(document).on('change.bundleAddon', '.bundle-addon__check', function () {
  //     var $addon = $(this).closest('bundle-addon');
  
  //     $addon.toggleClass('is-unchecked', !this.checked);
  //     updateBundleTotal($addon.closest('.product-form'));
  //   });
  
  //   function initBundleTotals() {
  //     $('.product-form').has('bundle-addon').each(function () {
  //       updateBundleTotal($(this));
  //     });
  //   }
  
  //   $(document).on('shopify:section:load', initBundleTotals);
  //   $(initBundleTotals);
  // })(jQuery);

  (function ($) {
    'use strict';
  
    var currencyFormat = window.themeVariables.settings.currencyCodeEnabled
      ? window.themeVariables.settings.moneyWithCurrencyFormat
      : window.themeVariables.settings.moneyFormat;
  
    function applyDiscount(cents, discount) {
      if (!discount) return cents;
  
      return Math.round((cents * (100 - discount)) / 100);
    }
  
    function updateBundleTotal($form) {
      var discount = parseFloat($form.attr('data-bundle-discount')) || 0;
      var mrp = 0;
      var price = 0;

      $form.find('bundle-addon').each(function () {
        var $addon = $(this);
        if (!$addon.find('.bundle-addon__check').prop('checked')) return;

        var addonPrice = parseInt($addon.attr('data-price'));
        price += addonPrice;
        mrp += parseInt($addon.attr('data-compare-price')) || addonPrice;
      });

      var cartPrice = applyDiscount(price, discount);
      var showCompare = mrp > cartPrice;

      // price-list
      $form.find('[data-bundle-price-value]').html(formatMoney(cartPrice, currencyFormat));
      $form.find('[data-bundle-price]').toggleClass('price--highlight', showCompare);
      // console.log('mrppppp',mrp)
      // console.log('cartPriceeee',cartPrice)
      $form.find('[data-bundle-compare-value]').html(formatMoney(price, currencyFormat));
      // $form.find('[data-bundle-compare-price]').prop('hidden', !showCompare);

      // ATC button
      // $form.find('[data-bundle-total]').html(formatMoney(cartPrice, currencyFormat));
      // $form.find('[data-bundle-total-compare]')
      //   .html(formatMoney(price, currencyFormat))
      //   .prop('hidden', cartPrice >= price);
    }
  
    function updateAddon($addon) {
      var variants = JSON.parse($addon.find('script[data-addon-variants]').text());
      var selected = [];
  
      $addon.find('[data-addon-option]:checked').each(function () {
        selected[parseInt(this.dataset.optionPosition, 10) - 1] = this.value;
      });
  
      var variant = variants.find(function (candidate) {
        return candidate.options.every(function (option, index) {
          return selected[index] === undefined || option === selected[index];
        });
      });
  
      if (!variant) return;
  
      $addon
        .attr('data-variant-id', variant.id)
        .attr('data-price', variant.price)
        .attr('data-compare-price', variant.compare_at_price || variant.price)
        .toggleClass('is-unavailable', !variant.available);
  
      $addon.find('[data-addon-price]').html(formatMoney(variant.price, currencyFormat));
      if (variant.image) {
        $addon.find('.bundle-addon__image')
          .removeAttr('srcset')
          .attr('src', variant.image);
      }
    }
  
    function collectItems($form, quantity) {
      var items = [];
  
      $form.find('bundle-addon').each(function () {
        var $addon = $(this);
  
        if (!$addon.find('.bundle-addon__check').prop('checked')) return;
        if ($addon.hasClass('is-unavailable')) return;
  
        items.push({
          id: parseInt($addon.attr('data-variant-id'), 10),
          quantity: quantity,
          properties: {
            '_type': 'main_bundle_item'
          }
        });
      });
  
      return items;
    }
  
    function addToCart($button) {
      var $form = $button.closest('.product-form');
      var quantity = parseInt($button.closest('bundle-form').find('[name="quantity"]').val(), 10) || 1;
      var items = collectItems($form, quantity);
  
      if (!items.length) return;
  
      $button.attr('aria-busy', 'true');
  
      $.ajax({
        url: window.themeVariables.routes.cartAddUrl + '.js',
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({ items: items })
      })
        .done(function () {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } })
          );
        })
        .fail(function (xhr) {
          alert((xhr.responseJSON && xhr.responseJSON.description) || 'Could not add to cart.');
        })
        .always(function () {
          $button.removeAttr('aria-busy');
        });
    }
  
    function initBundleTotals() {
      $('.product-form').has('bundle-addon').each(function () {
        $(this).find('bundle-addon').each(function () {
          updateAddon($(this));
        });
        updateBundleTotal($(this));
      });
    }
  
    $(document).off('.bundleAddon');
  
    $(document).on('click.bundleAddon', '[data-bundle-add-to-cart-button]', function (event) {
      event.preventDefault();
      addToCart($(this));
    });
  
    $(document).on('change.bundleAddon', '[data-addon-option]', function () {
      var $addon = $(this).closest('bundle-addon');
  
      updateAddon($addon);
      updateBundleTotal($addon.closest('.product-form'));
    });
  
    $(document).on('change.bundleAddon', '.bundle-addon__check', function () {
      var $addon = $(this).closest('bundle-addon');
  
      $addon.toggleClass('is-unchecked', !this.checked);
      updateBundleTotal($addon.closest('.product-form'));
    });
  
    $(document).on('shopify:section:load.bundleAddon', initBundleTotals);
    $(initBundleTotals);
  })(jQuery);

})

// class BundleAddon extends HTMLElement {
//     connectedCallback() {
//       var dataEl = this.querySelector('[data-addon-variants]');
//       this.variants = dataEl ? JSON.parse(dataEl.textContent) : [];
//       this.addEventListener('change', this._onChange.bind(this));
//       this._syncState();
//     }
 
//     get checkbox() {
//       return this.querySelector('.bundle-addon__check');
//     }
//     get checked() {
//       return !!(this.checkbox && this.checkbox.checked);
//     }
//     get variantId() {
//       return parseInt(this.dataset.variantId, 10);
//     }
//     get price() {
//       return parseInt(this.dataset.price, 10) || 0;
//     }
//     get formId() {
//       return this.getAttribute('form-id');
//     }
 
//     _onChange(event) {
//       if (event.target.hasAttribute('data-addon-option')) {
//         this._resolveVariant();
//       }
//       this._syncState();
//       this.dispatchEvent(new CustomEvent('bundle-addon:changed', { bubbles: true }));
//     }
 
//     /* Find the variant matching the checked radios (sorted by option position) */
//     _resolveVariant() {
//       var selected = Array.from(this.querySelectorAll('[data-addon-option]:checked'))
//         .sort(function (a, b) {
//           return a.dataset.optionPosition - b.dataset.optionPosition;
//         })
//         .map(function (input) {
//           return input.value;
//         });
 
//       var variant = this.variants.find(function (v) {
//         return v.options.length === selected.length &&
//           v.options.every(function (value, index) {
//             return value === selected[index];
//           });
//       });
 
//       if (variant) {
//         this.dataset.variantId = variant.id;
//         this.dataset.price = variant.price;
//         var priceEl = this.querySelector('[data-addon-price]');
//         if (priceEl) priceEl.textContent = formatMoney(variant.price);
//         this.classList.toggle('is-unavailable', !variant.available);
//       }
//     }
 
//     _syncState() {
//       this.classList.toggle('is-unchecked', !this.checked);
//     }
//   }
 
//   if (!window.customElements.get('bundle-addon')) {
//     window.customElements.define('bundle-addon', BundleAddon);
//   }
 
//   /* ------------------------------------------------------------------ */
//   /* Helpers                                                             */
//   /* ------------------------------------------------------------------ */
//   function addonsForForm(formId) {
//     return Array.from(document.querySelectorAll('bundle-addon[form-id="' + formId + '"]'));
//   }
 
//   function checkedAddons(formId) {
//     return addonsForForm(formId).filter(function (addon) {
//       return addon.checked;
//     });
//   }
 
//   function quantityFor(form) {
//     var qtyEl = form.elements['quantity'];
//     if (qtyEl && typeof RadioNodeList !== 'undefined' && qtyEl instanceof RadioNodeList) {
//       qtyEl = qtyEl[0]; // two quantity inputs share the name in this section
//     }
//     return qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
//   }
 
//   /* ------------------------------------------------------------------ */
//   /* Add-to-cart button total                                            */
//   /* ------------------------------------------------------------------ */
//   function updateTotal(form) {
//     if (!form) return;
//     var totalEl = form.querySelector('[data-bundle-total]');
//     if (!totalEl) return;
 
//     var basePrice = parseInt(totalEl.dataset.basePrice, 10) || 0;
//     var addonsTotal = checkedAddons(form.getAttribute('id')).reduce(function (sum, addon) {
//       return sum + addon.price;
//     }, 0);
 
//     totalEl.textContent = formatMoney(basePrice * quantityFor(form) + addonsTotal);
//   }
 
//   /* Add-on toggled / add-on variant changed */
//   document.addEventListener('bundle-addon:changed', function (event) {
//     updateTotal(document.forms[event.target.formId]);
//   });
 
//   /* Quantity changed */
//   document.addEventListener('change', function (event) {
//     if (event.target.name !== 'quantity') return;
//     var form = event.target.form ||
//       document.forms[event.target.getAttribute('form')];
//     if (form && form.querySelector('[data-bundle-total]')) updateTotal(form);
//   });
 
//   /* Main variant changed: the theme re-renders product-payment-container
//      synchronously right after this event, so wait one tick, then re-apply
//      the total (the fresh span carries the new variant's base price). */
//   document.addEventListener('variant:changed', function (event) {
//     var form = event.target;
//     if (form && form.tagName === 'FORM') {
//       setTimeout(function () { updateTotal(form); }, 10);
//     }
//   });
 
//   document.addEventListener('DOMContentLoaded', function () {
//     document.querySelectorAll('bundle-addon[form-id]').forEach(function (addon) {
//       updateTotal(document.forms[addon.formId]);
//     });
//   });
 
//   /* ------------------------------------------------------------------ */
//   /* Submit interception                                                 */
//   /* Capture phase on document runs before the theme's ProductForm       */
//   /* submit listener (which sits on the form itself).                    */
//   /* ------------------------------------------------------------------ */
//   document.addEventListener('submit', function (event) {
//     var form = event.target;
//     if (!(form instanceof HTMLFormElement) || form.getAttribute('is') !== 'product-form') return;
 
//     var addons = checkedAddons(form.getAttribute('id'));
//     if (addons.length === 0) return; // no add-ons: let the theme handle it normally
 
//     event.preventDefault();
//     event.stopPropagation();
//     submitBundle(form, addons);
//   }, true);
 
//   async function submitBundle(form, addons) {
//     if (!form.checkValidity()) {
//       form.reportValidity();
//       return;
//     }
 
//     var submitButtons = Array.from(form.elements).filter(function (el) {
//       return el.type === 'submit';
//     });
//     submitButtons.forEach(function (button) {
//       button.setAttribute('disabled', 'disabled');
//       button.setAttribute('aria-busy', 'true');
//     });
 
//     var bundleId = 'bundle-' + Date.now();
//     var items = [{
//       id: parseInt(form.elements['id'].value, 10),
//       quantity: quantityFor(form),
//       properties: { _bundle_id: bundleId }
//     }].concat(addons.map(function (addon) {
//       return { id: addon.variantId, quantity: 1, properties: { _bundle_id: bundleId } };
//     }));
 
//     var response, responseJson;
//     try {
//       response = await fetch(window.themeVariables.routes.cartAddUrl + '.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify({ items: items, sections: 'mini-cart' })
//       });
//       responseJson = await response.json();
//     } catch (error) {
//       submitButtons.forEach(function (button) {
//         button.removeAttribute('disabled');
//         button.removeAttribute('aria-busy');
//       });
//       return;
//     }
 
//     submitButtons.forEach(function (button) {
//       button.removeAttribute('disabled');
//       button.removeAttribute('aria-busy');
//     });
 
//     if (response.ok) {
//       if (window.themeVariables.settings.cartType === 'page' ||
//           window.themeVariables.settings.pageType === 'cart') {
//         window.location.href = Shopify.routes.root + 'cart';
//         return;
//       }
 
//       form.dispatchEvent(new CustomEvent('variant:added', {
//         bubbles: true,
//         detail: {
//           variant: responseJson.items ? responseJson.items[0] : responseJson
//         }
//       }));
 
//       var cartResponse = await fetch(window.themeVariables.routes.cartUrl + '.js');
//       var cartContent = await cartResponse.json();
 
//       document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
//         bubbles: true,
//         detail: { cart: cartContent }
//       }));
 
//       cartContent.sections = responseJson.sections;
 
//       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//         bubbles: true,
//         detail: {
//           cart: cartContent,
//           openMiniCart: window.themeVariables.settings.cartType === 'drawer' &&
//             form.closest('.drawer') === null
//         }
//       }));
//     } else {
//       form.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//     }
 
//     form.dispatchEvent(new CustomEvent('cart-notification:show', {
//       bubbles: true,
//       cancelable: true,
//       detail: {
//         status: response.ok ? 'success' : 'error',
//         error: (responseJson && responseJson.description) || ''
//       }
//     }));
//   }



// $(document).on('change', 'product-item .color-swatch__radio', function () {
//   var $input = $(this);
//   var $card = $input.closest('product-item');

//   /* ---------- 1. Image swap (only if variant has its own image) ---------- */
//   var mediaId = $input.attr('data-variant-featured-media');

//   if (mediaId) {
//     var $target = $card.find('.product-item__primary-image[data-media-id="' + mediaId + '"]');

//     if ($target.length) {
//       $card.find('.product-item__primary-image').attr('hidden', 'hidden');
//       $target.removeAttr('hidden');

//       // keep hover-secondary image from flashing over the new image
//       var ratio = ($target[0].naturalWidth && $target[0].naturalHeight)
//         ? $target[0].naturalWidth / $target[0].naturalHeight
//         : null;
//       if (ratio) {
//         $card.find('.product-item__aspect-ratio')
//           .css('padding-bottom', (100 / ratio) + '%')
//           .css('--aspect-ratio', ratio);
//       }
//     }
//     // no matching rendered image -> ignore, keep current image
//   }
//   // no variant image at all -> ignore, keep current image

//   /* ---------- 2. Secondary (hover) image swap ---------- */
//   var secondaryMediaId = $input.attr('data-variant-secondary-media');

//   if (secondaryMediaId) {
//     var $secondaryTarget = $card.find('.product-item__secondary-image[data-media-id="' + secondaryMediaId + '"]');

//     if ($secondaryTarget.length) {
//       $card.find('.product-item__secondary-image').attr('hidden', 'hidden');
//       $secondaryTarget.removeAttr('hidden');
//     }
//   }

//   /* ---------- 2. Price + compare price ---------- */
//   var price = $input.attr('data-variant-price') || '';
//   var comparePrice = $input.attr('data-variant-compare-price') || '';

//   if (!price) return;

//   var $swatchList = $input.closest('.product-item-meta__swatch-list');
//   var saleText = $swatchList.attr('data-sale-price-text') || 'Sale price';
//   var regularText = $swatchList.attr('data-regular-price-text') || 'Regular price';

//   var html = '';

//   if (comparePrice) {
//     html += '<span class="price price--highlight">' +
//               '<span class="visually-hidden">' + saleText + '</span>' + price +
//             '</span>' +
//             '<span class="price price--compare">' +
//               '<span class="visually-hidden">' + regularText + '</span>' + comparePrice +
//             '</span>';
//   } else {
//     html += '<span class="price">' +
//               '<span class="visually-hidden">' + saleText + '</span>' + price +
//             '</span>';
//   }

//   $card.find('.price-list').first().html(html);
// });

$(document).on('change', 'product-item .color-swatch__radio', function () {
  var $input = $(this);
  var $card = $input.closest('product-item');
  var variantId = $input.attr('data-variant-id');

  /* ---------- 1. Look up this variant's media from the JSON map ---------- */
  var $mediaMapEl = $card.find('[data-color-media-map]').first();
  var mediaMap = {};

  if ($mediaMapEl.length) {
    try {
      mediaMap = JSON.parse($mediaMapEl.text() || '{}');
    } catch (e) {
      mediaMap = {};
    }
  }

  var mediaForVariant = variantId ? mediaMap[variantId] : null;

  if (mediaForVariant) {

    /* ---- 1a. Primary image: rewrite src + aspect ratio ---- */
    if (mediaForVariant.primary && mediaForVariant.primary.url) {
      var $primaryImg = $card.find('.product-item__primary-image').first();

      if ($primaryImg.length) {
        $primaryImg
          .removeAttr('srcset')
          .attr('src', mediaForVariant.primary.url)
          .attr('data-media-id', mediaForVariant.primary.id);

        if (mediaForVariant.primary.alt) {
          $primaryImg.attr('alt', mediaForVariant.primary.alt);
        }

        if (mediaForVariant.primary.aspectRatio) {
          $card.find('.product-item__aspect-ratio')
            .css('padding-bottom', (100 / mediaForVariant.primary.aspectRatio) + '%')
            .css('--aspect-ratio', mediaForVariant.primary.aspectRatio);
        }
      }
    }

    /* ---- 1b. Secondary (hover) image: rewrite src ---- */
    var $secondaryImg = $card.find('.product-item__secondary-image').first();

    if ($secondaryImg.length) {
      if (mediaForVariant.secondary && mediaForVariant.secondary.url) {
        $secondaryImg
          .removeAttr('srcset')
          .attr('src', mediaForVariant.secondary.url)
          .attr('data-media-id', mediaForVariant.secondary.id);

        if (mediaForVariant.secondary.alt) {
          $secondaryImg.attr('alt', mediaForVariant.secondary.alt);
        }
      } else if (mediaForVariant.primary && mediaForVariant.primary.url) {
        // no distinct secondary image for this variant -> fall back to primary
        // so hover doesn't show a stale/mismatched image
        $secondaryImg
          .removeAttr('srcset')
          .attr('src', mediaForVariant.primary.url)
          .attr('data-media-id', mediaForVariant.primary.id);
      }
    }
  }
  // no entry for this variant in the map -> leave current images untouched

  /* ---------- 2. Price + compare price (unchanged) ---------- */
  var price = $input.attr('data-variant-price') || '';
  var comparePrice = $input.attr('data-variant-compare-price') || '';

  if (!price) return;

  var $swatchList = $input.closest('.product-item-meta__swatch-list');
  var saleText = $swatchList.attr('data-sale-price-text') || 'Sale price';
  var regularText = $swatchList.attr('data-regular-price-text') || 'Regular price';

  var html = '';

  if (comparePrice) {
    html += '<span class="price price--highlight">' +
              '<span class="visually-hidden">' + saleText + '</span>' + price +
            '</span>' +
            '<span class="price price--compare">' +
              '<span class="visually-hidden">' + regularText + '</span>' + comparePrice +
            '</span>';
  } else {
    html += '<span class="price">' +
              '<span class="visually-hidden">' + saleText + '</span>' + price +
            '</span>';
  }

  $card.find('.price-list').first().html(html);
});
$(function () {
  $('product-item .color-swatch__radio:checked').trigger('change');
});

// (function () {
//   var SECTION_ID = {{ section.id | json }};
//   var namespace = '.movementLibrary' + SECTION_ID.replace(/[^a-zA-Z0-9]/g, '');

//   function init(container) {
//     var $container = $(container);
//     var $grid = $container.find('[data-movement-library-grid]');
//     if (!$grid.length) return;

//     var $modal = $container.find('[data-movement-library-modal]');
//     var $stage = $modal.find('[data-movement-library-stage]');
//     var $modalTitle = $modal.find('[data-movement-library-modal-title]');
//     var $body = $('body');
//     var lastFocused = null;

//     function closeModal() {
//       if (!$modal.hasClass('is-open')) return;
//       var video = $stage.find('video').get(0);
//       if (video) {
//         video.pause();
//       }
//       $modal.removeClass('is-open').attr('aria-hidden', 'true');
//       $stage.empty();
//       $modalTitle.text('');
//       $body.removeClass('is-scroll-locked');
//       if (lastFocused) {
//         $(lastFocused).trigger('focus');
//         lastFocused = null;
//       }
//     }

//     function openModal($trigger) {
//       var index = $trigger.attr('data-movement-library-trigger');
//       var $template = $grid.find('[data-movement-library-source="' + index + '"]');
//       if (!$template.length) return;

//       lastFocused = $trigger.get(0);

//       var markup = $template.prop('content')
//         ? $($template.prop('content')).find('video').clone()
//         : $($template.html()).filter('video');

//       $stage.empty().append(markup);

//       var $card = $trigger.closest('.movement-library-block');
//       var title = $card.find('.movement-library__card-title').text();
//       $modalTitle.text(title || '');

//       $modal.addClass('is-open').attr('aria-hidden', 'false');
//       $body.addClass('is-scroll-locked');

//       var video = $stage.find('video').get(0);
//       if (video) {
//         video.load();
//         var playPromise = video.play();
//         if (playPromise && typeof playPromise.catch === 'function') {
//           playPromise.catch(function () {});
//         }
//       }

//       $modal.trigger('focus');
//     }

//     // Destroy-before-reinit guard
//     $grid.off(namespace);
//     $modal.off(namespace);
//     $(document).off('keydown' + namespace);

//     $grid.on('click' + namespace, '[data-movement-library-trigger]', function () {
//       openModal($(this));
//     });

//     $modal.on('click' + namespace, function (event) {
//       if (event.target === this) {
//         closeModal();
//       }
//     });

//     $modal.on('click' + namespace, '[data-movement-library-close]', function () {
//       closeModal();
//     });

//     $(document).on('keydown' + namespace, function (event) {
//       if (event.key === 'Escape' || event.keyCode === 27) {
//         closeModal();
//       }
//     });

//     $container.data('movementLibraryClose', closeModal);
//   }

//   function destroy(container) {
//     var $container = $(container);
//     var close = $container.data('movementLibraryClose');
//     if (typeof close === 'function') {
//       close();
//     }
//     $container.find('[data-movement-library-grid]').off(namespace);
//     $container.find('[data-movement-library-modal]').off(namespace);
//     $(document).off('keydown' + namespace);
//   }

//   var sectionEl = document.getElementById('shopify-section-' + SECTION_ID);
//   if (sectionEl) {
//     init(sectionEl);
//   }

//   $(document)
//     .on('shopify:section:load' + namespace, function (event) {
//       if (event.detail.sectionId === SECTION_ID) {
//         init(event.target);
//       }
//     })
//     .on('shopify:section:unload' + namespace, function (event) {
//       if (event.detail.sectionId === SECTION_ID) {
//         destroy(event.target);
//       }
//     });
// })();


$(document).ready(function () {
  if (window.innerWidth >= 1000) {
    $('body').on('click','.watch-videos-block-video-thumb', function () {
      $(this).closest('.watch-videos-block').find('.watch-video-block-modal').attr('open','true');
    })
    $('body').on('click', '.watch-video-block-modal .modal__close-button', function () {
        $(this).closest('.watch-video-block-modal').removeAttr('open');
    });
  }

  if (window.innerWidth <= 999) { 
    $('body').on('click','.watch-videos-block-video-thumb', function () {
      $(this).closest('.watch-videos-block').find('.watch-video-block-modal-mobile').addClass('active');
    })
    $('body').on('click', '.watch-video-block-modal-mobile .modal_mobile__close-button, .watch-video-block-modal-mobile .modal_mobile__overlay', function () {
        $(this).closest('.watch-video-block-modal-mobile').removeClass('active');
    });
  }

  document.addEventListener('variant:changed', function(event) {
    let variant_title = event.detail.variant.title; 
    console.log('variant_title',variant_title);
    $('.product__media-list_grid').find('.product__media-item').each(function () {
      let media_alt = $(this).attr('data-alt-tag');
      console.log('media_alt',media_alt);
      if (variant_title == media_alt) {
        $(this).removeClass('is-filtered');
        console.log('sameeeeee')
      } else {
        $(this).addClass('is-filtered');
      }
    })
  });
})